import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL, commonPayload } from '../apiStaticData/constants'
import { getCookie } from '../../../util/index';

export const apiSlice = createApi({
  reducerPath: 'apiSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      let token = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
      const isLoginPage = document.getElementById('txtInputName');
      if(!isLoginPage){
        headers.set('kxToken', token);
      }
      return headers
    },
    extraOptions: { maxRetries: 0 },
  }),
  endpoints: () => ({}),
})